






import {Component, Prop, Vue} from "vue-property-decorator";
import {StringHelpers} from "@common/StringHelpers";

@Component({
    name: "QualityTestMessage"
})
export default class QualityTestMessage extends Vue {
    @Prop({required: true}) uplinkQuality: number;
    @Prop({required: true}) downlinkQuality: number;

    get uplinkType() {
       return this.getQualityType(this.uplinkQuality);
    }

    get downlinkType() {
        return this.getQualityType(this.downlinkQuality);
    }

    get text() {
        const uplink = this.$t('device-test.quality.types.' + this.uplinkType);
        const downLink = this.$t('device-test.quality.types.' + this.downlinkType);

        return StringHelpers.capitalize(this.$t('device-test.quality.text', { downlinkQuality: downLink, uplinkQuality: uplink }).toString());
    }

    get conclusion() {
        const capitalizedUplinkType = StringHelpers.capitalize(this.uplinkType);
        const capitalizedDownlinkType =  StringHelpers.capitalize(this.downlinkType);
        if (this.uplinkType == this.downlinkType) {
            return this.$t('device-test.quality.conclusions.both' + capitalizedUplinkType);
        }

        return this.$t(`device-test.quality.conclusions.down${capitalizedDownlinkType}Up${capitalizedUplinkType}`);
    }

    getQualityType(quality: number) {
        if (quality == 1) {return 'good';}
        if (quality >= 2 && quality <= 4) {return 'average';}
        return 'low';
    }
}
